import { render, staticRenderFns } from "./aLabel.vue?vue&type=template&id=46222788"
import script from "./aLabel.vue?vue&type=script&lang=js"
export * from "./aLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports